// AccordianEditComponent.jsx
import { Accordion, AccordionBody, AccordionHeader, Button, Input } from "@material-tailwind/react";
import { useState } from "react";
import CKEditorInlineBubbleComponent from "@/StyledUIComponent/CKEditor/CKEditorInlineBubbleComponent.jsx";
import { deleteFaq, updateFaq } from "@/api/faqApi.jsx";

function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
}

const AccordianEditComponent = ({
                                    index,
                                    item,
                                    handleOpen,
                                    open,
                                    accessToken,
                                    refreshFaqs, // refreshFaqs prop 받기
                                }) => {
    const [edit, setEdit] = useState(false);
    const [content, setContent] = useState(item.des || "");
    const [title, setTitle] = useState(item.title || "");

    const handleDelete = (id) => {
        if (window.confirm("이 FAQ를 삭제하시겠습니까?")) {
            deleteFaq(id)
                .then((res) => {
                    if (res.status === 200) {
                        alert("FAQ가 성공적으로 삭제되었습니다.");
                        refreshFaqs(); // 삭제 후 데이터 다시 가져오기
                    } else {
                        alert("FAQ 삭제에 실패했습니다.");
                    }
                })
                .catch((err) => {
                    console.error("FAQ 삭제 오류:", err);
                    alert("FAQ 삭제 중 오류가 발생했습니다.");
                });
        }
    };

    const handleUpdate = () => {
        if (!title.trim() || !content.trim()) {
            alert("제목과 설명은 비워둘 수 없습니다.");
            return;
        }

        updateFaq({ title, des: content, id: item.id })
            .then((res) => {
                if (res.status === 200) {
                    alert("FAQ가 성공적으로 수정되었습니다.");
                    setEdit(false);
                    refreshFaqs(); // 수정 후 데이터 다시 가져오기
                } else {
                    alert("FAQ 수정에 실패했습니다.");
                }
            })
            .catch((err) => {
                console.error("FAQ 수정 오류:", err);
                alert("FAQ 수정 중 오류가 발생했습니다.");
            });
    };

    return (
        <Accordion
            open={open === index + 1}
            icon={<Icon id={item.id} open={open} />}
            className="mb-2"
        >
            <AccordionHeader
                className="flex items-center gap-2"
                onClick={() => handleOpen(index + 1)}
            >
                {edit ? (
                    <Input
                        className="w-full"
                        label="수정"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                ) : (
                    <div className="w-full flex justify-between">
                        <p>{title}</p>
                    </div>
                )}
                {accessToken && (
                    <div className="flex gap-4">
                        {!edit ? (
                            <Button
                                size="sm"
                                color="blue"
                                onClick={() => {
                                    setEdit(true);
                                    handleOpen(index + 1);
                                }}
                            >
                                Edit
                            </Button>
                        ) : (
                            <div className="flex gap-4">
                                <Button size="sm" color="green" onClick={handleUpdate}>
                                    Confirm
                                </Button>
                                <Button
                                    size="sm"
                                    color="red"
                                    onClick={() => {
                                        setEdit(false);
                                        setContent(item.des);
                                        setTitle(item.title);
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        )}
                        <Button
                            size="sm"
                            color="red"
                            onClick={() => handleDelete(item.id)}
                        >
                            Delete
                        </Button>
                    </div>
                )}
            </AccordionHeader>
            <AccordionBody className="text-left text-xl">
                {edit ? (
                    <CKEditorInlineBubbleComponent
                        content={content}
                        setContent={setContent}
                    />
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: item.des }} />
                )}
            </AccordionBody>
        </Accordion>
    );
};

export default AccordianEditComponent;